module.exports = __webpack_public_path__ + "static/media/avatar17.e3249f14.png";